module.exports = __webpack_public_path__ + "img/ic_mfm.01e8c2c8.svg";